import React from 'react';

export default function PriceDisplay({ price, originalPrice, align = 'left', wrapperClassName = '', currentClassName = '', originalClassName = '', currentStyle, originalStyle }) {
  const current = Math.max(0, Number(price) || 0);
  const original = Math.max(0, Number(originalPrice) || 0);
  const currency = value => '\u09f3' + value.toLocaleString();
  return (
    <span className={`inline-flex flex-nowrap items-start gap-1.5 whitespace-nowrap ${align === 'right' ? 'justify-end text-right' : 'text-left'} ${wrapperClassName}`}>
      <span className={`font-bold leading-none ${currentClassName}`} style={currentStyle}>{currency(current)}</span>
      {original > current && <sup className={`static shrink-0 text-[0.65em] font-normal leading-none text-gray-400 ${originalClassName}`} style={originalStyle}><del>{currency(original)}</del></sup>}
    </span>
  );
}
